<app-dashboard-shell
  title="AI Activations"
  description="Detailed view of AI activations and their costs. Click the expand button to view the conversation thread."
  [lastReload]="lastReload"
  [loading]="loading"
  (refresh)="triggerReload()"
>

  <div class="p-col-12">
    <div class="dashboard-card">
      <p-table
        [value]="tableData"
        [loading]="loading"
        [scrollable]="true"
        styleClass="p-datatable-sm"
        dataKey="threadId"
        rowExpandMode="multiple"
        [expandedRowKeys]="expandedRowKeys"
        [paginator]="true"
        [rows]="rowsPerPage"
        [rowsPerPageOptions]="[25, 50, 100]"
        [(first)]="first"
        (onPage)="onPageChange($event)"
        sortField="createdAt"
        sortOrder="-1"
      >
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 3rem"></th>
            <th pSortable="createdAt">Date<p-sortIcon field="createdAt"></p-sortIcon></th>
            <th>Job Code</th>
            <th>Customer</th>
            <th>Mode</th>
            <th pSortable="totalCost">Cost<p-sortIcon field="totalCost"></p-sortIcon></th>
            <th pSortable="promptTokens">Input Tokens<p-sortIcon field="promptTokens"></p-sortIcon></th>
            <th pSortable="completionTokens">Output Tokens<p-sortIcon field="completionTokens"></p-sortIcon></th>
            <th pSortable="totalTokens">Total Tokens<p-sortIcon field="totalTokens"></p-sortIcon></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData>
          <tr>
            <td>
              <button pButton type="button" [icon]="expandedRowKeys[rowData.threadId] ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" class="p-button-text p-button-sm" (click)="toggleExpand(rowData)"></button>
            </td>
            <td>{{ rowData.createdAt > 0 ? (rowData.createdAt | date:'yyyy-MM-dd HH:mm:ss') : '—' }}</td>
            <td><a *ngIf="rowData.jobUrl" [href]="rowData.jobUrl" target="_blank" class="job-link">{{ rowData.jobCode }}</a><span *ngIf="!rowData.jobUrl">{{ rowData.jobCode }}</span></td>
            <td><a *ngIf="rowData.customerUrl" [href]="rowData.customerUrl" target="_blank" class="customer-link">{{ rowData.customerName }}</a><span *ngIf="!rowData.customerUrl">{{ rowData.customerName }}</span></td>
            <td>{{ rowData.mode }}</td>
            <td>{{ rowData.totalCost | currency:'USD':'symbol':'1.2-4' }}</td>
            <td>{{ rowData.promptTokens | number }}</td>
            <td>{{ rowData.completionTokens | number }}</td>
            <td>{{ rowData.totalTokens | number }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="rowexpansion" let-rowData>
          <tr>
            <td colspan="9">
              <div class="p-pa-3" style="background: #f9f9f9; border-left: 4px solid #3b82f6;">
                <div *ngIf="!rowData.comments && loading" class="p-text-center p-mb-2">
                  <i class="pi pi-spin pi-spinner"></i> Loading...
                </div>
                <div *ngIf="rowData.comments?.length === 0 && !loading" class="p-text-center p-mb-2">
                  No messages found.
                </div>
                <ng-container *ngFor="let comment of rowData.comments">
                  <div class="thread-message">
                    <div class="thread-meta">
                      <strong>{{ comment.authorName || 'System' }}</strong><br>
                      <small>{{ comment.createdAt | date: 'short' }}</small>
                      <div *ngIf="comment.metadata?.ai_total_cost || comment.metadata?.ai_cost" style="font-size: 0.7em; color: #666;">
                        Cost: ${{ (comment.metadata.ai_total_cost || comment.metadata.ai_cost)?.toFixed?.(4) || '—' }}
                      </div>
                    </div>
                    <div [class]="'thread-content ' + (comment.system ? 'thread-content--system' : 'thread-content--user')">
                      {{ comment.text }}
                      <div *ngIf="comment.metadata?.ai_model || comment.metadata?.provider" style="font-size: 0.7em; opacity: 0.6; margin-top: 4px;">
                        <span *ngIf="comment.metadata?.ai_model">Model: {{ comment.metadata.ai_model }}</span>
                        <span *ngIf="comment.metadata?.ai_model && comment.metadata?.provider"> | </span>
                        <span *ngIf="comment.metadata?.provider">Provider: {{ comment.metadata.provider }}</span>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="9" class="p-text-center">No AI activation data found for the selected period.</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

</app-dashboard-shell>
